import React from 'react';

const TransationsIcon = () => {
    return (
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M2.2 14A10 10 0 0 1 12 2a9.94 9.94 0 0 1 7.1 3h-3.6v2h6a1 1 0 0 0 1-1V0h-2v3.57A12 12 0 0 0 .18 14zM21.8 10A10 10 0 0 1 12 22a9.94 9.94 0 0 1-7.1-3h3.6v-2h-6a1 1 0 0 0-1 1v6h2v-3.57A12 12 0 0 0 23.82 10z"/></svg>
    )
};

export default TransationsIcon;